import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {Typography} from "@material-ui/core";

const values = ["stock", "option"];

export default function InstrumentDropDown({top, dispatchTop}) {
    return (<>
        <TextField
            select
            value={top.instrument !== "none" ? top.instrument : ""}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => dispatchTop({instrument: ev.target.value})}
            label={<Typography style={{fontSize: 10}}>Instrument</Typography>}
        >
            {values.map((option) => (
                <MenuItem key={option} value={option}>
                    <Typography style={{fontSize: 9}}>{option}</Typography>
                </MenuItem>
            ))}
        </TextField>
    </>);
}